(() => {
  const SELECTOR = ".collection-card-variant-select";
  const WRAPPER_SELECTOR = "[data-card-price-wrapper]";
  const VARIANT_ID_INPUT_SELECTOR = 'input[name="id"]';

  function findNearestWrapper(selectEl) {
    // Walk up the DOM until we find an ancestor that contains a price wrapper
    let node = selectEl.parentElement;
    while (node) {
      const wrapper = node.querySelector(WRAPPER_SELECTOR);
      if (wrapper) return wrapper;
      node = node.parentElement;
    }
    return null;
  }

  document.addEventListener("change", (e) => {
    const selectEl = e.target.closest(SELECTOR);
    if (!selectEl) return;

    const option = selectEl.options?.[selectEl.selectedIndex];
    if (!option) return;

    // 1) Update hidden variant id so ATC uses the selected variant
    const form = selectEl.closest('form[action*="/cart/add"], form[data-type="add-to-cart-form"], form');
    const idInput = form?.querySelector(VARIANT_ID_INPUT_SELECTOR);
    if (idInput) idInput.value = option.value;

    // 2) Update price UI
    const wrapper = findNearestWrapper(selectEl);
    if (!wrapper) return;

    const price = option.dataset.price || "";
    const compare = option.dataset.comparePrice || "";

    wrapper.innerHTML = compare
      ? `<span>${price}</span> <s class="compare-at-price">${compare}</s>`
      : `<span>${price}</span>`;
  });
})();
